import { gql } from '@apollo/client';

const GET_SEO_DATA = gql`
  	query GetSeoData($uri: String!) {
		pageBy(uri: $uri) {
			title
			seo {
				title
				breadcrumbTitle
				canonicalUrl
				description
				focusKeywords
				fullHead
				isPillarContent
				robots
				seoScore {
					hasFrontendScore
					rating
					score
				}
				jsonLd {
					raw
				}
				openGraph {
					alternateLocales
					description
					locale
					siteName
					title
					type
					updatedTime
					url
					image {
						url
						type
						secureUrl
					}
        		}
			}
		}
	}
`;

export { GET_SEO_DATA }
